var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManatBrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 87,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2f1f19",
  d: "M35.04 11.16q7.08.72 11.76 4.32 4.8 3.48 7.68 10.92 2.88 7.32 4.08 19.2t1.2 29.28V87H49.68V76.32q0-16.08-.6-26.64T46.8 32.76q-1.56-6.36-4.44-9.24-2.88-3-7.32-3.72v58.8h-9.48V19.8q-4.56.72-7.44 3.72-2.76 2.88-4.44 9.24-1.56 6.36-2.16 16.92t-.6 26.64V87H.84V74.88q0-17.4 1.2-29.16 1.2-11.88 4.08-19.32t7.56-10.92q4.8-3.6 11.88-4.32V.72h9.48z"
})));
export default SvgManatBrown;